import React, { useEffect, useState } from 'react';
import { onErrorShowMessage } from '~src/errors';
import { fetchGiottoProducts } from '~graphql/controllers';
import ProductCard from './ProductCard';

const ProductsPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const result = await fetchGiottoProducts();
        if (!mounted) return;
        setCategories(result || []);
      } catch (err) {
        console.error(err);
        onErrorShowMessage();
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="products-content">
      <section className="products-hero">
        <div className="products-hero__headline">
          <h1>Crea e ordina i tuoi prodotti</h1>
        </div>
      </section>

      <section className="products-list">
        {loading && (
          <div className="g-text-center g-text-muted">Caricamento…</div>
        )}

        {!loading && categories.length === 0 && (
          <div className="g-text-center g-text-muted">
            Nessun prodotto disponibile.
          </div>
        )}

        {!loading &&
          categories.map((cat, idx) => {
            const items = (Array.isArray(cat.items) ? cat.items : []).filter(
              Boolean
            );
            return (
              <div key={`${cat.name}-${idx}`} className="products-category">
                <h2 className="products-category__title">{cat.name}</h2>
                <div className="products-grid g-grid g-grid-cards">
                  {items.map((it, j) => {
                    const pid = it?.product_pointer?.objectId;
                    const name = it?.product_pointer?.nome || '—';
                    const org = it?.product_pointer?.org_pointer?.nome || '';
                    const imageUrl = it?.product_pointer?.img?.url;
                    return (
                      <ProductCard
                        key={`${pid || name}-${j}`}
                        name={name}
                        orgName={org}
                        imageUrl={imageUrl}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
      </section>
    </div>
  );
};

export default ProductsPage;
